/**
 * Плитка-кнопка SOS для дашборда/холла гостя (design-guest §15.4 — красная
 * SOS на видном месте). Ведёт на экран /sos с подтверждением (не создаёт
 * заявку сразу — двойное подтверждение на самом экране SOS).
 */
import { useNavigate } from 'react-router-dom';

export function SosTile(): JSX.Element {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="sos-tile"
      onClick={() => navigate('/sos')}
      data-testid="sos-tile"
    >
      <span className="sos-tile__icon" aria-hidden="true">
        ⚠
      </span>
      <span className="sos-tile__text">
        <span className="sos-tile__title">SOS — срочная помощь</span>
        <span className="sos-tile__sub">Экстренный вызов персонала</span>
      </span>
    </button>
  );
}
